// ─────────────────────────────────────────────────────────────────────────────
// format.js — every display formatter on the Dashboard, in one place so the
// charts and their tooltips can't drift into disagreeing about how a day or a
// duration is written.
// ─────────────────────────────────────────────────────────────────────────────

// getUTCDay, not getDay: the API's dates are UTC calendar days, so a local-time
// read would shift the label by one for viewers west of UTC.
const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/** "2025-05-14" → "Wed" */
export function dayLabel(dateStr) {
  const d = new Date(dateStr);
  return Number.isNaN(d.getTime()) ? dateStr : DAY_NAMES[d.getUTCDay()];
}

/** "2025-05-14" → "14.05.2025" (the tooltip date format from the design) */
export function tooltipDate(dateStr) {
  const [y, m, d] = (dateStr || "").split("-");
  return d ? `${d}.${m}.${y}` : "";
}

/** 5400 → "1h 30m", 90 → "1m", 5 → "5s" */
export function humanDuration(sec) {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  if (h) return `${h}h ${m}m`;
  if (m) return `${m}m`;
  return `${sec}s`;
}

/**
 * KPI tile value: hundredths for a float (84.20 → "84.2"), millions abbreviated
 * for a big count (1_400_000 → "1.4M"), thousands-separated otherwise.
 * `raw` is the count-up animation's current integer — hundredths when isFloat.
 */
export function statValue(raw, isFloat) {
  if (isFloat) return (raw / 100).toFixed(2).replace(/\.?0+$/, "");
  if (raw >= 1_000_000) return `${(raw / 1_000_000).toFixed(1)}M`;
  return raw.toLocaleString();
}
